/**
 * Leitura do conforto do setor do posto (`GET /:id/comfort`). O erro não derruba a etapa: quem usa
 * mostra "não foi possível ler as medições agora" e segue com o resto.
 */
import { useCallback } from 'react';
import { ergonomicWorkstationService } from '../../../../services/ergonomicWorkstationService';
import type { ErgonomicComfort } from '../../../../types/ergonomicWorkstation';
import { useItems } from './useItems';

export const COMFORT_FAILURE = 'Não foi possível ler as medições agora.';

/** Sem posto salvo ainda não há o que ler: devolve estado parado, sem chamada. */
export function useComfort(workstationId: number | null) {
  const load = useCallback(async (): Promise<ErgonomicComfort[]> => {
    if (workstationId === null) return [];
    return [await ergonomicWorkstationService.comfort(workstationId)];
  }, [workstationId]);

  const { items, loading, error, reload } = useItems<ErgonomicComfort>(load, COMFORT_FAILURE);
  return { comfort: items[0] ?? null, loading, error: error ? COMFORT_FAILURE : null, reload };
}
